import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const platform = searchParams.get('connected');
    const status = searchParams.get('status');
    const googleType = searchParams.get('googleType'); // 'analytics' | 'ads' | null

    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'oauth-callback',
          platform,
          googleType,
          status,
        },
        window.location.origin,
      );
      window.close();
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-neutral-50">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full bg-steel-600/10 flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-steel-600 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
        <p className="text-sm text-neutral-600">Completing connection...</p>
      </div>
    </div>
  );
}
